<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <form (submit)="onCancellationPolicySubmit()" class="m-4" *ngIf="eventType !== null">

      <div class="row">
        <div class="col-md-8 col-xl-6">

          <div class="form-group">
            <label for="allowCustomerCancellationSelect">
              Can customers cancel reservations?
            </label>
            <select id="allowCustomerCancellationSelect"
                    class="custom-select" name="allowCustomerCancellationSelect"
                    [(ngModel)]="eventType.allow_customer_cancellation">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
            <div class="form-text text-danger">{{ eventTypeErrors.allow_customer_cancellation }}</div>
          </div>

          <div class="form-group" *ngIf="eventType.allow_customer_cancellation">
            <label for="customerCancellationWindowHoursInput">
              How many hours before the start of an event may a customer cancel?
            </label>
            <input id="customerCancellationWindowHoursInput"
                   name="customerCancellationWindowHoursInput"
                   type="number" class="form-control" step="1" required
                   [(ngModel)]="eventType.customer_cancellation_window_hours">
            <div class="form-text text-danger">{{ eventTypeErrors.customer_cancellation_window_hours }}</div>
          </div>

          <ng-container *ngIf="eventType.allow_customer_cancellation">

            <div class="form-group">
              <label for="customer_cancellation_currency_refund_amount">
                Should the customer be refunded their (currency) fee when they cancel a booking?
              </label>
              <select id="customer_cancellation_currency_refund_amount"
                      name="customer_cancellation_currency_refund_amount"
                      class="custom-select"
                      [(ngModel)]="eventType.customer_cancellation_currency_refund_amount">
                <option [ngValue]="CurrencyRefundAmount.full">Yes, Full Amount</option>
                <option [ngValue]="CurrencyRefundAmount.perParticipantFeeOnly">Yes, Per-Participant Fees Only (Plus Add-Ons)</option>
                <option [ngValue]="CurrencyRefundAmount.perBookingFeeOnly">Yes, Per-Booking Fees Only (Plus Add-Ons)</option>
                <option [ngValue]="CurrencyRefundAmount.noRefund">No</option>
              </select>
              <div class="alert alert-info"
                   *ngIf="eventType.customer_cancellation_currency_refund_amount === CurrencyRefundAmount.perParticipantFeeOnly">
                Per-participant fees and any add-on fees will be refunded. Per-booking fees will <b>not</b> be refunded.
              </div>
              <div class="alert alert-info"
                   *ngIf="eventType.customer_cancellation_currency_refund_amount === CurrencyRefundAmount.perBookingFeeOnly">
                Per-booking fees and any add-on fees will be refunded. Per-participant fees will <b>not</b> be refunded.
              </div>
              <div class="form-text text-danger">{{ eventTypeErrors.customer_cancellation_currency_refund_amount }}</div>
            </div>

            <div class="form-group indented-subsection"
                 *ngIf="eventType.customer_cancellation_currency_refund_amount !== CurrencyRefundAmount.noRefund">
              <label for="customer_cancellation_currency_refund_as_credit">
                How should the currency refund be credited?
              </label>
              <select id="customer_cancellation_currency_refund_as_credit"
                      name="customer_cancellation_currency_refund_as_credit"
                      class="custom-select"
                      [(ngModel)]="eventType.customer_cancellation_currency_refund_as_credit">
                <option [ngValue]="false">To the original payment method</option>
                <option [ngValue]="true">As account credit</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.customer_cancellation_currency_refund_as_credit }}</div>
            </div>

            <div class="form-group">
              <label for="refund_voucher_on_customer_cancellation">
                Should the customer be refunded any vouchers used when they cancel a booking?
              </label>
              <select id="refund_voucher_on_customer_cancellation"
                      name="refund_voucher_on_customer_cancellation"
                      class="custom-select"
                      [(ngModel)]="eventType.refund_voucher_on_customer_cancellation">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.refund_voucher_on_customer_cancellation }}</div>
            </div>

          </ng-container>

        </div>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="eventTypeErrors.non_field_errors">
        {{ eventTypeErrors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="eventTypeErrorMessage">
        {{ eventTypeErrorMessage }}
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingEventType">
        Loading...
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <!-- Invisible button causes the "enter" keypress to be of submit type continue. -->
        <button type="submit" style="display: none" (click)="submitType=SUBMIT_TYPE_CONTINUE"></button>
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="loadingEventType" [class.disabled]="loadingEventType"
                (click)="submitType=SUBMIT_TYPE_GO_BACK">
          Save and Go Back
        </button>
        <button type="submit" class="btn btn-primary"
                [disabled]="loadingEventType" [class.disabled]="loadingEventType"
                (click)="submitType=SUBMIT_TYPE_CONTINUE">
          Save and Continue
        </button>
      </div>
      <button [routerLink]="['/events/setup/event-types']"
              [queryParams]="{status: eventType?.status}"
              [disabled]="isLoading()" [class.disabled]="isLoading()"
              class="btn btn-secondary">
        Back
      </button>

    </form>

  </div>

</div>
